import React, { createContext, useContext, useState, ReactNode } from "react";

interface HeaderContextType {
  breadcrumbTitle: string | null;
  setBreadcrumbTitle: (title: string | null) => void;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export function HeaderProvider({ children }: { children: ReactNode }) {
  const [breadcrumbTitle, setBreadcrumbTitle] = useState<string | null>(null);

  return (
    <HeaderContext.Provider value={{ breadcrumbTitle, setBreadcrumbTitle }}>
      {children}
    </HeaderContext.Provider>
  );
}

export function useHeader() {
  const context = useContext(HeaderContext);
  if (context === undefined) {
    throw new Error("useHeader must be used within a HeaderProvider");
  }
  return context;
}














